import { render, staticRenderFns } from "./DetectionsThumbnailView.vue?vue&type=template&id=449c3f34&"
import script from "./DetectionsThumbnailView.vue?vue&type=script&lang=js&"
export * from "./DetectionsThumbnailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports